import { useSelector } from "react-redux";
import get from "lodash/get";

function useSelectedScraper() {
    return useSelector((state) => get(state, "selectedScraper.value", false));
}

export default useSelectedScraper;
